 document.addEventListener("DOMContentLoaded", () => {
    if (!customElements.get("tab-container")) {
      class TabContainer extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          const tabButtons = this.querySelectorAll(".tab-button");

          tabButtons.forEach((tabButton) => {
            // Use a common function to handle both click and touch events
            const handleTabInteraction = (event) => {
              event.stopPropagation();
              const currentTabContentId =
                tabButton.getAttribute("data-tab-content");
              const currentTabContent = this.querySelector(currentTabContentId);

              // Remove 'is-active' class from all tab buttons
              tabButtons.forEach((button) => {
                button.classList.remove("is-active");
              });

              // Add 'is-active' class to the clicked tab button
              tabButton.classList.add("is-active");

              // Remove 'is-active' class from all tab contents
              this.querySelectorAll(".tab-content").forEach((tabContent) => {
                tabContent.classList.remove("is-active");
              });

              // Add 'is-active' class to the corresponding tab content
              currentTabContent.classList.add("is-active");

              const slider = currentTabContent.querySelector(".vertical-slider");
              const items = slider.querySelectorAll(".how__to_item");

              let sliderHeight = 0;

              items.forEach((item, index) => {
                const itemHeight = item.clientHeight;
                console.log(itemHeight);
                if (index < 4) {
                  sliderHeight += itemHeight;
                }
              });
              if (slider) {
                slider.style.height = sliderHeight + "px";
              }
            };

            // Attach both click and touch event listeners to the button
            tabButton.addEventListener("click", handleTabInteraction);
            tabButton.addEventListener("touchstart", handleTabInteraction);
          });
        }
      }

      customElements.define("tab-container", TabContainer);
    }
  });

